import React, { useState } from 'react';
import { Button } from '../ui/button';

import SelectField from '@/components/atoms/SelectField';
import EditSubscriptionIcon from '@/assets/icons/edit-subscription.svg';

interface EditSubscriptionModalProps {
  isOpen: boolean;
  onButtonClick: () => void;
  onClose?: () => void;
}

const EditSubscriptionModal: React.FC<EditSubscriptionModalProps> = ({ isOpen, onButtonClick, onClose = () => {} }) => {
  if (!isOpen) return null;

  const [plan, setPlan] = useState<string>('');

  return (
    <div className="fixed w-screen h-screen top-0 left-0 bg-[rgba(82,80,96,0.5)] backdrop-blur-[8px] z-50 flex items-center justify-center">
      <div className="bg-white rounded-[16px] w-[327px] overflow-hidden">
        <div className="w-full py-7 px-7 md:p-0 flex flex-col items-center justify-center gap-2">
          <div className="rounded-t-[16px] md:bg-lightPurple w-full md:mb-4 md:py-8">
            <img className="mb-3 md:h-[140px] md:w-[140px] mx-auto" src={EditSubscriptionIcon} alt={`icon`} />
          </div>
          <p className="md:px-4 font-bold text-xl text-center leading-[24.3px] md:mb-[0.15rem]">
            Change Subscription Plan
          </p>
          <div className="w-full md:px-5">
            <SelectField
              name="plan"
              options={[
                { label: 'Basic', value: 'basic' },
                { label: 'Standard', value: 'standard' },
                { label: 'Pro', value: 'pro' },
                { label: 'Yearly', value: 'yearly' }
              ]}
              value={plan}
              onChange={(value) => {
                setPlan(value as string);
              }}
              buttonClassName="h-[40px] !py-[10px] !px-4"
              // className="w-[480px]"
            />
          </div>
        </div>
        <div className="flex md:gap-4 md:px-5 md:mb-6 md:mt-6">
          <Button
            onClick={onClose}
            className={`w-full !text-gray font-semibold h-[52px] !rounded-none md:text-[1rem] md:font-semibold md:!rounded-full md:h-[44px]`}
            variant={'primary-reverse'}
          >
            Cancel
          </Button>

          <Button
            onClick={onButtonClick}
            className={`w-full text-base font-semibold h-[52px] !rounded-none md:text-[1rem] md:font-semibold md:!rounded-full md:h-[44px]`}
          >
            Change
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EditSubscriptionModal;
